import {
  COLLINEAR_EPS,
  SEGMENT_OVERLAP_EPS,
  LinesetClosestSegmentResult,
  LinesetGridSpace,
  LinesetPerimeterPoint,
  LinesetTwoLevelTransition,
  appendWithoutDuplicates,
  closestPointOnSegment,
  computeHomePerimeter as computeSharedHomePerimeter,
  computeSegmentOverlap,
  distance,
  findClosestPerimeterPair,
  findClosestPerimeterPoint,
  findClosestPerimeterPointToPolygon,
  findContainingSpace,
  findEntryForTarget,
  findTwoLevelTransition,
  getSpaceAbsolutePolygon,
  isPointInPolygon,
  pathLength,
  simplifyPath,
  snapPointToPerimeterIfInside,
  toFootprintPolygons,
  walkPerimeter
} from '@alpinehomeair/common';
import { PositionType } from 'data/types';

export type GridSpace = LinesetGridSpace & {
  openTo?: string[];
};

export type ClosestSegmentResult = LinesetClosestSegmentResult;
export type PerimeterPoint = LinesetPerimeterPoint;
export type TwoLevelTransition = LinesetTwoLevelTransition;

export {
  COLLINEAR_EPS,
  SEGMENT_OVERLAP_EPS,
  appendWithoutDuplicates,
  closestPointOnSegment,
  computeSegmentOverlap,
  distance,
  findClosestPerimeterPair,
  findClosestPerimeterPoint,
  findClosestPerimeterPointToPolygon,
  findContainingSpace,
  findEntryForTarget,
  findTwoLevelTransition,
  getSpaceAbsolutePolygon,
  isPointInPolygon,
  pathLength,
  simplifyPath,
  snapPointToPerimeterIfInside,
  toFootprintPolygons,
  walkPerimeter
};

export function computeHomePerimeter(
  spaces: GridSpace[],
  extraPolygons: PositionType[][] = []
): PositionType[][] {
  return computeSharedHomePerimeter(spaces, extraPolygons, (error) => {
    console.warn(
      'computeHomePerimeter: polygon union failed; using unmerged rings',
      error
    );
  });
}
